// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"styles_logoContainer__A9NVQ","merchantNameContainer":"styles_merchantNameContainer__Eg7U_","component":"styles_component__w4Tmg"};